


































































































import { Component, Prop } from "vue-property-decorator";
import _ from "lodash";

import AppVue from "@/AppVue.vue";
import {
  QuestionnaireModel,
  CriticalSkillModel,
  SkillsStrategyModel,
  QuestionnaireLookups,
  SimpleLookupModel,
} from "@/core/models";
import { InputFieldCpt, InputTextareaCpt, InputSelectWithIconButtonCpt } from "@/core/components";
import AddNewMatchSkillDialogCpt from "./AddNewMatchSkillDialogCpt.vue";
import { StrategyType } from "@/core/constants";

@Component({
  components: {
    InputFieldCpt,
    InputTextareaCpt,
    InputSelectWithIconButtonCpt,
    AddNewMatchSkillDialogCpt,
  },
})
export default class QuestionnaireStep2Cpt extends AppVue {
  @Prop() lookups: QuestionnaireLookups;
  @Prop() model: QuestionnaireModel;
  @Prop({ default: false }) disabled: boolean;

  showAddMatchSkillDialog = false;
  currentSkill?: CriticalSkillModel = undefined;

  created() {
    if (this.model.criticalSkills.length === 0) {
      this.addSkill();
    }
  }

  get maxSkillAmountReached() {
    return this.model.criticalSkills.length === 10;
  }

  matchSkillDialogClosed(result: SimpleLookupModel) {
    this.showAddMatchSkillDialog = false;
    if (result) {
      this.$eventHub.$emit("MATCH_SKILL_ADDED", result, this.currentSkill);
    }
    this.currentSkill = undefined;
  }

  addNewMatchSkill(skill: CriticalSkillModel) {
    this.currentSkill = skill;
    this.showAddMatchSkillDialog = true;
  }

  addSkill(name?: string) {
    this.model.criticalSkills.push(
      new CriticalSkillModel({
        name,
        strategies1: this.createStrategies(StrategyType.Current),
        strategies2: this.createStrategies(StrategyType.New),
      }),
    );
  }

  goToSkill(index: number) {
    this.$eventHub.$emit("QNR_GO_TO_SUBSTEP", index);
  }

  deleteSkill(index: number) {
    if (confirm("Are you sure you want to delete this item?")) {
      this.model.criticalSkills.splice(index, 1);
    }
  }

  private createStrategies(strategyTypeId: number) {
    return _.flatMap(this.lookups.strategies, strategy => {
      return _.map(this.lookups.strategyLevels, strategyLevel => {
        return {
          strategyTypeId,
          strategyId: strategy.id,
          strategyLevelId: strategyLevel.id,
          isSelected: false,
        } as SkillsStrategyModel;
      });
    });
  }
}
